import { defineComponent as m, createElementBlock as s, createCommentVNode as o, openBlock as a, createElementVNode as l, renderSlot as n, Fragment as p, renderList as i, createBlock as d } from "vue";
import c from "./ParameterListItem.vue.js";
const h = {
  key: 0,
  class: "parameter-list"
}, u = { class: "parameter-list-title" }, b = { class: "parameter-list-items" }, E = /* @__PURE__ */ m({
  __name: "ParameterList",
  props: {
    parameters: {},
    showChildren: { type: Boolean, default: !1 },
    collapsableItems: { type: Boolean, default: !1 },
    withExamples: { type: Boolean, default: !0 },
    schemas: {},
    breadcrumb: {}
  },
  setup(f) {
    return (e, w) => {
      var t;
      return (t = e.parameters) != null && t.length ? (a(), s("div", h, [
        l("div", u, [
          n(e.$slots, "title", {}, void 0, !0)
        ]),
        l("ul", b, [
          (a(!0), s(p, null, i(e.parameters, (r) => (a(), d(c, {
            key: r.name,
            breadcrumb: e.breadcrumb,
            collapsableItems: e.collapsableItems,
            parameter: r,
            schemas: e.schemas,
            showChildren: e.showChildren,
            withExamples: e.withExamples
          }, null, 8, ["breadcrumb", "collapsableItems", "parameter", "schemas", "showChildren", "withExamples"]))), 128))
        ])
      ])) : o("", !0);
    };
  }
});
export {
  E as default
};
